import React, { useState, useEffect } from 'react';
import { post, get } from "../../../helpers/api_helper";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ManageBankDetails = () => {
  const [bankDetails, setBankDetails] = useState({
    bankName: '',
    accountHolderName: '',
    accountNumber: '',
    ifscCode: '',
  });

  const [bankDetailsExist, setBankDetailsExist] = useState(false);

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await get('/getUserBankDetails');
    
        
        if (response.bankDetails.length > 0) {
         
          setBankDetails(response.bankDetails[0])
          setBankDetailsExist(true)
        } else {
          console.log('No bank details exist');
         
        }
      } catch (error) {
        console.error('Error fetching bank details:', error);
      }
    };
  
    fetchBankDetails();
  }, []);
  
  console.log(bankDetails)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({ ...bankDetails, [name]: value });
  };
  console.log(bankDetailsExist)
  const handleUpdateBankDetails = (e) => {
    e.preventDefault();

    if (bankDetailsExist) {
      post('/updateBankDetails', bankDetails)
        .then((response) => {
          if (response.status === '1') {
            toast.success(response.message);
          }
        })
        .catch((error) => {
          console.error('Error updating bank details:', error);
          toast.error('Error updating bank details');
        });
    } else {

      post('/addBankDetails', bankDetails)
        .then((response) => {
          if (response.status === '1') {
            setBankDetailsExist(true);
            window.location.reload();
            toast.success('Bank details added successfully');
          }
        })
        .catch((error) => {
          console.error('Error adding bank details:', error);
          toast.error('Error adding bank details');
        });
    }
  };

  return (
    <div className="p-4">
      <ToastContainer />
      {bankDetailsExist ? (
        <form onSubmit={handleUpdateBankDetails} className="bg-white rounded p-4 shadow-xl">
          <h2 className="text-2xl font-bold mb-4">Your Bank Details</h2>
          <div className="mb-2">
            <label htmlFor="bankName" className="block font-semibold text-gray-700">Bank Name</label>
            <input
              type="text"
              id="bankName"
              name="bankName"
              value={bankDetails.bankName}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="accountHolderName" className="block font-semibold text-gray-700">Account Holder Name</label>
            <input
              type="text"
              id="accountHolderName"
              name="accountHolderName"
              value={bankDetails.accountHolderName}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="accountNumber" className="block font-semibold text-gray-700">Account Number</label>
            <input
              type="text"
              id="accountNumber"
              name="accountNumber"
              value={bankDetails.accountNumber}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="ifscCode" className="block font-semibold text-gray-700">IFSC Code</label>
            <input
              type="text"
              id="ifscCode"
              name="ifscCode"
              value={bankDetails.ifscCode}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <button type="submit" className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600">
            Update Bank Details
          </button>
        </form>
      ) : (
        <form onSubmit={handleUpdateBankDetails} className="bg-white rounded p-4 shadow-md">
          <h2 className="text-2xl font-bold mb-4">Add Bank Details</h2>
          <div className="mb-2">
            <label htmlFor="bankName" className="block font-semibold text-gray-700">Bank Name</label>
            <input
              type="text"
              id="bankName"
              name="bankName"
              value={bankDetails.bankName}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="accountHolderName" className="block font-semibold text-gray-700">Account Holder Name</label>
            <input
              type="text"
              id="accountHolderName"
              name="accountHolderName"
              value={bankDetails.accountHolderName}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="accountNumber" className="block font-semibold text-gray-700">Account Number</label>
            <input
              type="text"
              id="accountNumber"
              name="accountNumber"
              value={bankDetails.accountNumber}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <div className="mb-2">
            <label htmlFor="ifscCode" className="block font-semibold text-gray-700">IFSC Code</label>
            <input
              type="text"
              id="ifscCode"
              name="ifscCode"
              value={bankDetails.ifscCode}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-400"
            />
          </div>
          <button type="submit" className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600">
            Add Bank Details
          </button>
        </form>
      )}
    </div>
  );
};

export default ManageBankDetails;
